/* basic. production runtime adapter */
const lipThumbs = [...document.querySelectorAll('.lip-product .pdp-thumb')];
lipThumbs.forEach(thumb => {
  if (!thumb.dataset.src) thumb.dataset.src = thumb.dataset.gallerySrc || '';
  if (!thumb.dataset.alt) thumb.dataset.alt = thumb.dataset.galleryAlt || '';
});
const lipMainPhoto = document.querySelector('#lip-main-photo, #catalog-main-image');
let lipPhotoIndex = 0;

function showLipPhoto(index, force = false) {
  if (!lipMainPhoto || !lipThumbs.length) return;
  const nextIndex = (index + lipThumbs.length) % lipThumbs.length;
  if (nextIndex === lipPhotoIndex && !force) return;
  const next = lipThumbs[nextIndex];
  lipPhotoIndex = nextIndex;
  (window.BasicProductImages ? window.BasicProductImages.setImage(lipMainPhoto, next.dataset.src) : (lipMainPhoto.removeAttribute('srcset'), lipMainPhoto.src = next.dataset.src));
  lipMainPhoto.alt = next.dataset.alt;
  lipMainPhoto.classList.toggle('is-lip-use', next.dataset.src.includes('lip-lifestyle'));
  lipMainPhoto.classList.toggle('is-lip-applicator', next.dataset.src.includes('lip-applicator'));
  lipThumbs.forEach((thumb, thumbIndex) => {
    const selected = thumbIndex === nextIndex;
    thumb.classList.toggle('is-active', selected);
    thumb.setAttribute('aria-pressed', String(selected));
  });
}

lipThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showLipPhoto(index)));
document.querySelector('#lip-photo-prev, [data-gallery-prev]')?.addEventListener('click', () => showLipPhoto(lipPhotoIndex - 1));
document.querySelector('#lip-photo-next, [data-gallery-next]')?.addEventListener('click', () => showLipPhoto(lipPhotoIndex + 1));
let lipTouchX = null;
document.querySelector('#lip-main-image, .lip-product .pdp-main-image')?.addEventListener('touchstart', event => {
  lipTouchX = event.changedTouches[0].screenX;
}, {passive:true});
document.querySelector('#lip-main-image, .lip-product .pdp-main-image')?.addEventListener('touchend', event => {
  if (lipTouchX === null) return;
  const difference = event.changedTouches[0].screenX - lipTouchX;
  if (Math.abs(difference) > 45) showLipPhoto(lipPhotoIndex + (difference < 0 ? 1 : -1));
  lipTouchX = null;
}, {passive:true});

const lipDialog = document.querySelector('#lip-ugc-dialog');
const lipFeed = document.querySelector('#lip-ugc-feed');
const lipSlides = [...lipFeed.querySelectorAll('.kit-ugc-slide')];
const lipBefore = lipSlides[1].cloneNode(true);
const lipAfter = lipSlides[0].cloneNode(true);
lipBefore.setAttribute('aria-hidden', 'true');
lipAfter.setAttribute('aria-hidden', 'true');
lipBefore.querySelector('video').preload = 'none';
lipAfter.querySelector('video').preload = 'none';
lipFeed.prepend(lipBefore);
lipFeed.append(lipAfter);
const lipVideos = [...lipFeed.querySelectorAll('video')];
let lipActiveVideo = -1;
let lipScrollFrame = 0;
let lipWrapTimer = 0;
let lipResetting = false;
let lipVideoOpener = null;

function playLipVideo(index, resumeTime = null, muted = false) {
  if (!lipDialog.open || index === lipActiveVideo || index < 0 || index >= lipVideos.length) return;
  lipActiveVideo = index;
  lipVideos.forEach((video, videoIndex) => {
    if (videoIndex === index) return;
    video.pause();
    if (video.readyState) video.currentTime = 0;
  });
  const video = lipVideos[index];
  if (resumeTime !== null && video.readyState) video.currentTime = resumeTime;
  video.muted = muted;
  video.play().catch(() => {
    if (!lipDialog.open || lipActiveVideo !== index) return;
    video.muted = true;
    video.play().catch(() => {});
  });
}

function wrapLipFeed() {
  if (!lipDialog.open || lipResetting) return;
  const height = lipFeed.clientHeight;
  const index = Math.round(lipFeed.scrollTop / height);
  if (Math.abs(lipFeed.scrollTop - index * height) > 2) return;
  const target = index === 0 ? 2 : index === 3 ? 1 : null;
  if (target === null) return;
  const time = lipVideos[index].currentTime;
  const muted = lipVideos[index].muted;
  lipResetting = true;
  lipFeed.style.scrollSnapType = 'none';
  lipFeed.scrollTop = target * height;
  playLipVideo(target, time, muted);
  requestAnimationFrame(() => {
    lipFeed.style.scrollSnapType = '';
    lipResetting = false;
  });
}

function openLipFeed(event) {
  lipVideoOpener = event.currentTarget;
  lipDialog.showModal();
  document.body.classList.add('kit-ugc-open');
  lipResetting = true;
  lipFeed.style.scrollSnapType = 'none';
  lipFeed.scrollTop = lipFeed.clientHeight;
  lipActiveVideo = -1;
  playLipVideo(1);
  requestAnimationFrame(() => {
    lipFeed.style.scrollSnapType = '';
    lipResetting = false;
  });
  document.querySelector('#lip-ugc-close').focus();
}
document.querySelector('#lip-ugc-open')?.addEventListener('click', openLipFeed);
document.querySelector('#lip-ugc-open-secondary').addEventListener('click', openLipFeed);
lipFeed.addEventListener('scroll', () => {
  if (lipResetting) return;
  cancelAnimationFrame(lipScrollFrame);
  lipScrollFrame = requestAnimationFrame(() => {
    playLipVideo(Math.round(lipFeed.scrollTop / lipFeed.clientHeight));
  });
  clearTimeout(lipWrapTimer);
  lipWrapTimer = setTimeout(wrapLipFeed, 120);
}, {passive:true});
lipFeed.addEventListener('scrollend', wrapLipFeed);
lipDialog.addEventListener('keydown', event => {
  const direction = ['ArrowDown', 'PageDown', ' '].includes(event.key) ? 1
    : ['ArrowUp', 'PageUp'].includes(event.key) ? -1 : 0;
  if (!direction) return;
  event.preventDefault();
  const index = Math.round(lipFeed.scrollTop / lipFeed.clientHeight);
  const next = Math.max(0, Math.min(lipVideos.length - 1, index + direction));
  lipFeed.scrollTo({top:next * lipFeed.clientHeight,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});
document.querySelector('#lip-ugc-close').addEventListener('click', () => lipDialog.close());
lipDialog.addEventListener('close', () => {
  cancelAnimationFrame(lipScrollFrame);
  clearTimeout(lipWrapTimer);
  lipVideos.forEach(video => {
    video.pause();
    if (video.readyState) video.currentTime = 0;
  });
  lipActiveVideo = -1;
  lipResetting = false;
  document.body.classList.remove('kit-ugc-open');
  lipVideoOpener?.focus();
});

const lipForm = document.querySelector('#lip-cart-form');
const lipTiers = [...document.querySelectorAll('.lip-kit-page .kit-tier-option')];
const lipColors = [...document.querySelectorAll('input[name="lip-color-choice"]')];
const lipFormulas = [...document.querySelectorAll('.lip-kit-page .kit-formula-option')];
const lipCounts = Object.fromEntries(lipFormulas.map(option => [option.dataset.formula, 0]));
const lipCartItems = document.querySelector('#lip-cart-items');

function lipPlural(count) { return count <= 1 ? 'lot' : 'lots'; }
function lipMoney(amount) { return 'CHF ' + amount + '.–'; }

function lipSelection() {
  const color = lipColors.find(input => input.checked);
  const selected = lipFormulas.filter(option => lipCounts[option.dataset.formula] > 0);
  const total = selected.reduce((sum, option) => sum + lipCounts[option.dataset.formula], 0);
  const offer = total >= 5 ? 'free' : total >= 2 ? 'duo' : 'starter';
  // Les paliers ont été vérifiés dans des paniers anonymes pour 1 à 6 lots.
  const price = total >= 1 && total <= 6 ? 12 + total * 9 - (total >= 5 ? 12 : total >= 2 ? 3 : 0) : null;
  const compareAt = price === null ? null : 12 + total * 9;
  const savings = compareAt === null ? 0 : compareAt - price;
  return {color, selected, total, offer, price, compareAt, savings};
}

function addLipInput(name, value) {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = String(value);
  lipCartItems.append(input);
}

function renderLipCartItems(selection) {
  lipCartItems.replaceChildren();
  const lines = [
    {id:selection.color.dataset.id,quantity:1},
    ...selection.selected.map(option => ({id:option.dataset.id,quantity:lipCounts[option.dataset.formula]}))
  ];
  lines.forEach((line, index) => {
    addLipInput('items[' + index + '][id]', line.id);
    addLipInput('items[' + index + '][quantity]', line.quantity);
  });
}

function updateLipColorPhoto(color) {
  const thumb = lipThumbs[2];
  thumb.dataset.src = color.dataset.image;
  thumb.dataset.alt = 'Applicateur KIIMA ' + color.dataset.name + ' ouvert, avec son baume';
  thumb.setAttribute('aria-label', 'Voir l’applicateur ' + color.dataset.name);
  (window.BasicProductImages ? window.BasicProductImages.setImage(thumb.querySelector('img'), color.dataset.image) : (thumb.querySelector('img').removeAttribute('srcset'), thumb.querySelector('img').src = color.dataset.image));
  showLipPhoto(2, true);
}

function updateLipFormulaPhoto(option) {
  const thumb = lipThumbs[3];
  const photo = option.querySelector('.lip-formula-photo');
  thumb.dataset.src = photo.getAttribute('src');
  thumb.dataset.alt = 'Deux baumes de la formule ' + option.dataset.name;
  thumb.setAttribute('aria-label', 'Voir le lot de baumes ' + option.dataset.name);
  (window.BasicProductImages ? window.BasicProductImages.setImage(thumb.querySelector('img'), thumb.dataset.src) : (thumb.querySelector('img').removeAttribute('srcset'), thumb.querySelector('img').src = thumb.dataset.src));
  showLipPhoto(3, true);
}

function updateLipUI() {
  const selection = lipSelection();
  lipTiers.forEach(tier => {
    const active = selection.total > 0 && tier.dataset.offer === selection.offer;
    tier.classList.toggle('is-selected', active);
    tier.setAttribute('aria-current', String(active));
  });
  lipColors.forEach(input => input.closest('.kit-color-option').classList.toggle('is-selected', input === selection.color));
  document.querySelector('#lip-selected-color').textContent = selection.color.dataset.name;
  document.querySelector('#lip-refill-count').textContent = selection.total + ' ' + lipPlural(selection.total) + ' ' + (selection.total <= 1 ? 'choisi' : 'choisis');
  lipFormulas.forEach(option => {
    const quantity = lipCounts[option.dataset.formula];
    option.classList.toggle('is-selected', quantity > 0);
    option.querySelector('output').textContent = String(quantity);
    option.querySelector('.kit-step-minus').disabled = quantity === 0;
  });
  const help = document.querySelector('#lip-formula-help');
  help.textContent = selection.total === 0
    ? 'Ajoute au moins un lot. Chaque lot contient deux baumes de la même formule.'
    : selection.total === 1
      ? 'Ton kit est prêt. Un deuxième lot active CHF 3 de remise.'
      : selection.total === 4
        ? 'Ajoute un cinquième lot sans payer plus : 10 baumes pour CHF 45.–'
        : selection.total >= 5 && selection.total <= 6
          ? 'Ton applicateur est offert. Tu peux encore ajouter des lots.'
          : selection.total > 6
            ? 'Ton kit est prêt. Le prix exact apparaît dans le panier.'
            : 'CHF 3 de remise sont activés. Continue si tu veux mélanger les formules.';
  help.classList.toggle('is-complete', selection.total > 0);
  help.classList.toggle('is-opportunity', selection.total === 4);
  document.querySelector('#lip-current-offer').textContent = selection.total === 0
    ? 'Les paliers suivront ta sélection.'
    : selection.total === 1
      ? 'Palier actuel : pour commencer.'
      : selection.total < 5
        ? 'Palier actuel : CHF 3 de remise.'
        : 'Palier actuel : applicateur offert.';
  const names = selection.selected.map(option => option.dataset.name + ' × ' + lipCounts[option.dataset.formula]).join(', ');
  document.querySelector('#lip-summary-contents').textContent = selection.total === 0
    ? '1 applicateur + 1 lot de deux baumes à choisir'
    : '1 applicateur + ' + selection.total + ' ' + lipPlural(selection.total) + ' de 2 baumes · ' + names;
  const price = selection.total === 0 ? 'Dès CHF 21.–' : selection.price === null ? 'Prix au panier' : lipMoney(selection.price);
  document.querySelector('#lip-summary-price').textContent = price;
  document.querySelector('#lip-add-price').textContent = price;
  document.querySelector('#lip-sticky-price').textContent = price;
  document.querySelector('#lip-sticky-count').textContent = selection.total + ' ' + lipPlural(selection.total);
  document.querySelector('#lip-add-label').textContent = selection.total === 0 ? 'Choisis un lot' : selection.price === null ? 'Voir mon prix au panier' : 'Ajouter mon kit';
  const comparison = document.querySelector('#lip-summary-compare');
  comparison.hidden = selection.savings === 0;
  comparison.textContent = selection.savings ? lipMoney(selection.compareAt) + ' séparément' : '';
  const savings = document.querySelector('#lip-savings');
  savings.hidden = selection.savings === 0;
  if (selection.savings) {
    const amount = document.createElement('strong');
    amount.textContent = lipMoney(selection.savings) + ' économisés';
    savings.replaceChildren(amount);
  } else {
    savings.replaceChildren();
  }
  const checkoutNote = document.querySelector('#lip-checkout-note');
  checkoutNote.hidden = selection.total <= 6;
  checkoutNote.textContent = selection.total > 6 ? 'Pour plus de 6 lots, les remises et le prix final devront être confirmés lors de la commande.' : '';
  const complete = selection.total > 0;
  document.querySelector('#lip-add-button').disabled = !complete;
  const stickyButton = document.querySelector('#lip-mobile-buy button');
  stickyButton.disabled = !complete;
  stickyButton.textContent = !complete ? 'Choisir un lot' : selection.price === null ? 'Voir au panier' : 'Ajouter mon kit';
  renderLipCartItems(selection);
}

lipColors.forEach(input => input.addEventListener('change', () => {
  updateLipUI();
  updateLipColorPhoto(input);
}));
lipFormulas.forEach(option => {
  const key = option.dataset.formula;
  option.querySelector('.kit-step-minus').addEventListener('click', () => {
    if (lipCounts[key] === 0) return;
    lipCounts[key]--;
    updateLipUI();
    const visibleFormula = lipCounts[key] > 0 ? option : lipSelection().selected[0];
    if (visibleFormula) updateLipFormulaPhoto(visibleFormula);
    else showLipPhoto(0);
  });
  option.querySelector('.kit-step-plus').addEventListener('click', () => {
    lipCounts[key]++;
    updateLipUI();
    updateLipFormulaPhoto(option);
  });
});
lipForm.addEventListener('submit', event => {
  const selection = lipSelection();
  if (selection.total < 1) {
    event.preventDefault();
    document.querySelector('#lip-formulas').scrollIntoView({behavior:'smooth',block:'center'});
    return;
  }
  renderLipCartItems(selection);
});
updateLipUI();

const lipSticky = document.querySelector('#lip-mobile-buy');
const lipClosing = document.querySelector('.lip-closing');
function updateLipSticky() {
  const passedForm = lipForm.getBoundingClientRect().bottom < 82;
  const nearEnd = lipClosing.getBoundingClientRect().top < window.innerHeight * .82;
  const visible = window.innerWidth <= 700 && passedForm && !nearEnd && !document.body.classList.contains('menu-locked') && !document.body.classList.contains('kit-ugc-open');
  lipSticky.classList.toggle('is-visible', visible);
  lipSticky.setAttribute('aria-hidden', String(!visible));
  lipSticky.inert = !visible;
}
window.addEventListener('scroll', updateLipSticky, {passive:true});
window.addEventListener('resize', updateLipSticky);
new MutationObserver(updateLipSticky).observe(document.body, {attributes:true,attributeFilter:['class']});
updateLipSticky();
